import SlabVaultLegacy from './SlabVaultLegacy';

// Collection display is a projection; receiving stays in canonical inventory.
export default function SlabVault() {
  return <SlabVaultLegacy canonicalReceiving />;
}
